import { createRoute } from '@tanstack/react-router';
import { rootRoute } from '../index';

const terms = createRoute({
  getParentRoute: () => rootRoute,
  path: 'terms',
}).lazy(() => import('#ui/page/PageTerms').then(d => d.Route));

const privacy = createRoute({
  getParentRoute: () => rootRoute,
  path: 'privacy',
}).lazy(() => import('#ui/page/PagePrivacy').then(d => d.Route));

const paths = () => ({
  terms: terms.fullPath,
  privacy: privacy.fullPath,
});

export { paths, terms, privacy };
